// extracted by mini-css-extract-plugin
module.exports = {"navbar":"navbar_navbar__hCO_W","has-child":"navbar_has-child__Ey8NP","submenu":"navbar_submenu__8i0WB","item":"navbar_item__WattZ"};